var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttentionNeededPageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.7901 66.8941H64.8528C65.5505 66.8941 66.116 66.3286 66.116 65.631V39.4017L59.2847 32.5703H37.8603C37.1626 32.5703 36.5972 33.1358 36.5972 33.8335V37.2555",
    stroke: "#1E247E",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5972 36.418V65.6322C36.5972 66.3299 37.1626 66.8953 37.8603 66.8953H41.9718",
    stroke: "#1E247E",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5977 63.941H34.893C34.1954 63.941 33.6299 63.3755 33.6299 62.6778V30.8804C33.6299 30.1827 34.1954 29.6172 34.893 29.6172H61.413C62.124 29.6172 62.7002 30.1934 62.7002 30.9038V35.9843",
    stroke: "#1E247E",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2832 32.5703V39.4004L66.1145 39.4017",
    stroke: "#1E247E",
    strokeWidth: 2.01813,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8052 44.4062H58.9371",
    stroke: "#DA867D",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8052 48.1406H58.9371",
    stroke: "#DA867D",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9487 51.9453H58.9381",
    stroke: "#DA867D",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8052 51.9453H52.9705",
    stroke: "#DA867D",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6831 64.2255C58.6831 60.1874 55.4098 56.9141 51.3711 56.9141C47.3324 56.9141 44.0591 60.1874 44.0591 64.2255C44.0591 68.2636 47.3324 71.537 51.3711 71.537C55.4098 71.537 58.6831 68.2636 58.6831 64.2255Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 2.01813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4697 60.8672V64.7858",
    stroke: "black",
    strokeWidth: 1.30611,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1232 67.3915C52.1232 67.7522 51.8308 68.0446 51.4701 68.0446C51.1093 68.0446 50.8169 67.7522 50.8169 67.3915C50.8169 67.0307 51.1093 66.7383 51.4701 66.7383C51.8308 66.7383 52.1232 67.0307 52.1232 67.3915Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionNeededPageIcon);
export default __webpack_public_path__ + "static/media/AttentionNeededPageIcon.4825ce2da0961eadc608f2332439437d.svg";
export { ForwardRef as ReactComponent };